import { LocaleType } from '@hhgtech/hhg-components/types'

import { COUNTRY_CURRENCY_SYMBOL } from 'interfaces/types/Ecommerce'

export function isDefined<T>(argument: T | undefined | null): argument is T {
  return argument !== undefined && argument !== null
}

export function isNullOrUndefinedOrEmptyString<T>(
  argument: T | null | undefined | '',
): argument is T {
  return argument === undefined || argument === null || argument === ''
}

export function trimObjectForQuery(object: {
  [k: string]: string | number | null | undefined
}) {
  Object.keys(object).forEach((k) => {
    if (isNullOrUndefinedOrEmptyString(object[k])) delete object[k]
  })
  return object
}

export function numberWithCommas(x: number | string) {
  if (!x) return ''
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export function currencyFormat(
  x: number | string,
  locale: LocaleType,
  currency: string,
) {
  if (!x || !locale) return `0 ${COUNTRY_CURRENCY_SYMBOL['vi-VN'] || ''}`

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(Number(x))
}
